import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Com from './assets/js/com'

Vue.prototype.$ComJs = Com
// import te from './utils/te'
//vant
import Vant from 'vant'
import {
  Toast
} from 'vant';
import 'vant/lib/index.css'

Toast.allowMultiple(); //允许同时存在多个 Toast
Vue.use(Vant);


Vue.config.productionTip = false

// 使用 router.beforeEach 注册一个全局前置守卫
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if ('keepAlive' in from.meta) {
    const el = document.querySelector('.page');
    from.meta.keepAlive = el.scrollTop || 0;
  }
  next();

});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/main.js